<template>
  <div>
    <CollapsibleCard
      :value="true"
      collapsibleIcon="mdi-certificate-outline"
      collapsibleTitle="Kurs og sertifikater"
      :padding="true"
      class="mb-6"
    >
      <template v-slot>
        <div v-if="!coursesLoading">
          <v-subheader style="height: 30px">Dine kompetanser</v-subheader>
          <CompetenceList :courses="coursesContactPerson" />

          <v-btn
            v-if="!haveAlleCourese"
            @click="showCompetencDialog = true"
            class="my-2"
            block
            outlined
          >
            <v-icon>mdi-plus</v-icon>
            Legg til kompetanse
          </v-btn>
          <CompetenceDialog v-model="showCompetencDialog" />
        </div>
        <div v-else class="text-center">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      </template>
    </CollapsibleCard>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

import CollapsibleCard from "@/components/shared/cards/CollapsibleCard.vue";
import CompetenceDialog from "@/components/shared/dialog/CompetenceDialog.vue";
import CompetenceList from "@/components/profile/children/CompetenceList.vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "Competence",
  data: () => ({
    showCompetencDialog: false,
  }),
  computed: {
    ...mapGetters({
      haveAlleCourese: "courses/haveAlleCourese",
      coursesContactPerson: "courses/coursesContactPerson",
      coursesLoading: "courses/coursesLoading",
    }),
  },
  components: {
    CollapsibleCard,
    CompetenceDialog,
    CompetenceList,
  },
});
</script>
